import { render, staticRenderFns } from "./rechargePassword.vue?vue&type=template&id=bb246b9c&scoped=true"
import script from "./rechargePassword.vue?vue&type=script&lang=js"
export * from "./rechargePassword.vue?vue&type=script&lang=js"
import style0 from "./rechargePassword.vue?vue&type=style&index=0&id=bb246b9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb246b9c",
  null
  
)

export default component.exports